import React from 'react';
import { Outlet } from 'react-router-dom';
import { useCompanyBranding } from '../common/hooks/use-company-branding';

export const CompanyBrandingProvider = () => {
  const { companyName, logoUrl, isCompanyContext } = useCompanyBranding();

  return (
    <>
      {isCompanyContext && (
        <div className="flex items-center justify-center gap-[8px] py-[6px] text-[12px] text-[#818185] dark:text-[#6B6B6F] font-body">
          {logoUrl && <img src={logoUrl} alt="" className="w-[20px] h-[20px] rounded-[4px] object-cover" />}
          {companyName && <span className="font-medium" style={{ color: 'var(--color-brand-primary)' }}>{companyName}</span>}
          <span className="text-[10px] dark:text-[#6B6B6F]">Powered by Standby</span>
        </div>
      )}
      <Outlet />
    </>
  );
};
